import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorCircleIcon from '@mui/icons-material/Error';
import CancelCircleIcon from '@mui/icons-material/Cancel';

import baseStyles from '@ts-core/styles/baseStyles';

const useStyles = makeStyles((theme) => ({
  ...baseStyles(theme),
}));

const AnswerTypeIcon = (props) => {
  const classes = useStyles();
  const { type } = props;
  if (type === 'positive') {
    return <CheckCircleIcon className={classes.optionPositive} />;
  }
  if (type === 'neutral') {
    return <CancelCircleIcon className={classes.optionNeutral} />;
  }
  if (type === 'negative') {
    return <CancelCircleIcon className={classes.optionNegative} />;
  }
  return <ErrorCircleIcon className={classes.optionNone} />;
};

AnswerTypeIcon.propTypes = {
  type: PropTypes.string,
};

AnswerTypeIcon.defaultProps = {
  type: undefined,
};

export default AnswerTypeIcon;
